import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import "./Cadetes.css";

import CadetesBuscador from "./CadetesBuscador";
import Modal from "./Modal";
import CadeteFormEdit from "./CadeteFormEdit";
import ListadoSecciones from "./ListadoSecciones";

import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import socket from "../tools/socke";
import InfoCadete from "../tools/InfoCadete";

const Cadetes = () => {
  const Usuario = ObtieneDatosCookies();
  const navigate = useNavigate();

  const [veoCadete, setVeoCadete] = useState(false);
  const [porPromocion, setPorPromocion] = useState(false);

  const [
    cadeteSeleccionado,
    setCadeteSeleccionado,
  ] = useState(null);

  const [
    categoriaElegida,
    setCategoriaElegida,
  ] = useState("");

  const destinosConMenuViejo = [
    "22",
    "21",
    "9",
    "7",
    "1",
    "25",
    "2",
    "16",
    "23"
  ];

  const puedeVerMenuViejo =
    destinosConMenuViejo.includes(
      String(Usuario?.destino)
    );

  // ============================================================
  // SELECCIONAR CADETE
  // ============================================================

  const manejoCadete = (cadete) => {
    setCadeteSeleccionado(cadete);

    if (cadete?.cadeteDni) {
      InfoCadete(cadete.cadeteDni);
    }

    setVeoCadete(true);
  };

  // ============================================================
  // ACTUALIZAR CADETE
  // ============================================================

  const actualizaCadete = async (data) => {
    try {
      const dataCadete = data;

      const operacion =
        "Actualiza Cadete";

      const payload = {
        Cadete: dataCadete,

        Usuario: {
          userID:
            Usuario.identificacion,

          cadeteDni:
            dataCadete.cadeteDni,

          Operacion:
            operacion,
        },
      };

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizoCadete/${dataCadete.cadeteDni}`,
        payload
      );

      if (response) {
        socket.emit(
          "reempadrone",
          dataCadete.cadeteDni
        );

        setVeoCadete(false);
        setCadeteSeleccionado(null);
      }
    } catch (error) {
      console.error(
        "Error actualizando cadete:",
        error
      );
    }
  };

  // ============================================================
  // CATEGORIA
  // ============================================================

  const manejarCategoria = (
    categoria
  ) => {
    setCategoriaElegida(categoria);
  };

  // ============================================================
  // MENU VIEJO
  // ============================================================

  const ViejoCadetes = () => {
    navigate("/cadetes");
  };

  // ============================================================
  // CERRAR MODAL
  // ============================================================

  const cerrarModalCadete = () => {
    setVeoCadete(false);
    setCadeteSeleccionado(null);
  };

  return (
    <div className="cad-v2-page">
      <div className="cad-v2-container">

        {/* =================================================== */}
        {/* CABECERA */}
        {/* =================================================== */}

        <section className="cad-v2-header">

          <div>
            <span className="cad-v2-eyebrow">
              GESTIÓN DE CADETES · ISeP
            </span>

            <h1 className="cad-v2-title">
              Cadetes
            </h1>

            <p className="cad-v2-subtitle">
              Consulta, edición y generación
              de listados de cadetes.
            </p>
          </div>

          {puedeVerMenuViejo && (
            <button
              type="button"
              className="cad-v2-btn-secondary"
              onClick={ViejoCadetes}
            >
              Abrir menú anterior
            </button>
          )}

        </section>

        {/* =================================================== */}
        {/* BUSCADOR */}
        {/* =================================================== */}

        <section className="cad-v2-search-card">

          <div className="cad-v2-search-info">

            <div className="cad-v2-search-icon">
              🔎
            </div>

            <div>
              <h2>
                Buscar cadete
              </h2>

              <p>
                Ingrese DNI, apellido,
                nombre u otro criterio
                disponible en el buscador.
              </p>
            </div>

          </div>

          <div className="cad-v2-search-box">
            <CadetesBuscador
              devuelvo={(cadete) =>
                manejoCadete(cadete)
              }
            />
          </div>

        </section>

        {/* =================================================== */}
        {/* ACCIONES */}
        {/* =================================================== */}

        <section className="cad-v2-actions-grid">

          <div className="cad-v2-action-card">

            <div className="cad-v2-action-icon">
              👤
            </div>

            <div className="cad-v2-action-content">
              <span>
                CONSULTA
              </span>

              <strong>
                Información de Cadetes
              </strong>

              <small>
                Busque un cadete para ver
                o editar sus datos.
              </small>
            </div>

          </div>

          <button
            type="button"
            className={`cad-v2-action-card cad-v2-action-button ${
              porPromocion
                ? "cad-v2-action-active"
                : ""
            }`}
            onClick={() =>
              setPorPromocion(
                (prev) => !prev
              )
            }
          >

            <div className="cad-v2-action-icon cad-v2-action-icon-print">
              🖨
            </div>

            <div className="cad-v2-action-content">
              <span>
                LISTADOS
              </span>

              <strong>
                Imprimir listados
              </strong>

              <small>
                Genere listados por división,
                sección, compañía, sede o promoción.
              </small>
            </div>

            <span
              className={`cad-v2-chevron ${
                porPromocion
                  ? "cad-v2-chevron-open"
                  : ""
              }`}
            >
              ▼
            </span>

          </button>

        </section>

        {/* =================================================== */}
        {/* LISTADOS */}
        {/* =================================================== */}

        {porPromocion && (
          <section className="cad-v2-section">

            <div className="cad-v2-section-header">

              <div className="cad-v2-section-title-group">

                <div className="cad-v2-indicator" />

                <div>
                  <h2>
                    Generar listados
                  </h2>

                  <p>
                    Seleccione el criterio
                    de agrupación para obtener
                    el listado correspondiente.
                  </p>
                </div>

              </div>

              <span className="cad-v2-badge">
                Impresión
              </span>

            </div>

            <div className="cad-v2-section-content">

              {/* ============================================= */}
              {/* SELECTOR DE CATEGORIA */}
              {/* ============================================= */}

              <div className="cad-v2-category-grid">

                <button
                  type="button"
                  className={`cad-v2-category-button ${
                    categoriaElegida ===
                    "DivisionEstudio"
                      ? "cad-v2-category-active"
                      : ""
                  }`}
                  onClick={() =>
                    manejarCategoria(
                      "DivisionEstudio"
                    )
                  }
                >
                  <span className="cad-v2-category-icon">
                    🧩
                  </span>

                  <strong>
                    División de Estudio
                  </strong>

                  <small>
                    Agrupar por división
                  </small>
                </button>

                <button
                  type="button"
                  className={`cad-v2-category-button ${
                    categoriaElegida ===
                    "Seccion"
                      ? "cad-v2-category-active"
                      : ""
                  }`}
                  onClick={() =>
                    manejarCategoria(
                      "Seccion"
                    )
                  }
                >
                  <span className="cad-v2-category-icon">
                    📋
                  </span>

                  <strong>
                    Sección
                  </strong>

                  <small>
                    Agrupar por sección
                  </small>
                </button>

                <button
                  type="button"
                  className={`cad-v2-category-button ${
                    categoriaElegida ===
                    "Compania"
                      ? "cad-v2-category-active"
                      : ""
                  }`}
                  onClick={() =>
                    manejarCategoria(
                      "Compania"
                    )
                  }
                >
                  <span className="cad-v2-category-icon">
                    🏢
                  </span>

                  <strong>
                    Compañía
                  </strong>

                  <small>
                    Agrupar por compañía
                  </small>
                </button>

                <button
                  type="button"
                  className={`cad-v2-category-button ${
                    categoriaElegida ===
                    "Sede"
                      ? "cad-v2-category-active"
                      : ""
                  }`}
                  onClick={() =>
                    manejarCategoria(
                      "Sede"
                    )
                  }
                >
                  <span className="cad-v2-category-icon">
                    📍
                  </span>

                  <strong>
                    Sede
                  </strong>

                  <small>
                    Agrupar por sede
                  </small>
                </button>

                <button
                  type="button"
                  className={`cad-v2-category-button ${
                    categoriaElegida ===
                    "Promocion"
                      ? "cad-v2-category-active"
                      : ""
                  }`}
                  onClick={() =>
                    manejarCategoria(
                      "Promocion"
                    )
                  }
                >
                  <span className="cad-v2-category-icon">
                    🎓
                  </span>

                  <strong>
                    Promoción
                  </strong>

                  <small>
                    Agrupar por promoción
                  </small>
                </button>

              </div>

              {/* ============================================= */}
              {/* RESULTADO */}
              {/* ============================================= */}

              {categoriaElegida ? (
                <div className="cad-v2-listado-wrapper">

                  <div className="cad-v2-listado-header">

                    <div>
                      <span>
                        CRITERIO SELECCIONADO
                      </span>

                      <strong>
                        {categoriaElegida ===
                        "DivisionEstudio"
                          ? "División de Estudio"
                          : categoriaElegida}
                      </strong>
                    </div>

                    <button
                      type="button"
                      className="cad-v2-clear-category"
                      onClick={() =>
                        setCategoriaElegida("")
                      }
                    >
                      Cambiar
                    </button>

                  </div>

                  <div className="cad-v2-listado-content">
                    <ListadoSecciones
                      categoria={
                        categoriaElegida
                      }
                    />
                  </div>

                </div>
              ) : (
                <div className="cad-v2-empty">

                  <div className="cad-v2-empty-icon">
                    🖨
                  </div>

                  <strong>
                    Seleccione un criterio
                  </strong>

                  <span>
                    Elija una categoría superior
                    para generar el listado.
                  </span>

                </div>
              )}

            </div>

          </section>
        )}

      </div>

      {/* ===================================================== */}
      {/* MODAL EDICION */}
      {/* ===================================================== */}

      {veoCadete &&
        cadeteSeleccionado && (
          <Modal
            isOpen={veoCadete}
            onClose={
              cerrarModalCadete
            }
          >
            <div className="cad-v2-modal">

              <div className="cad-v2-modal-header">

                <span className="cad-v2-modal-eyebrow">
                  LEGAJO DEL CADETE
                </span>

                <h3>
                  Información del cadete
                </h3>

                <div className="cad-v2-modal-person">

                  <div className="cad-v2-avatar">
                    {cadeteSeleccionado
                      ?.cadeteApellido
                      ?.charAt(0)
                      ?.toUpperCase() ||
                      cadeteSeleccionado
                        ?.cadeteNombre
                        ?.charAt(0)
                        ?.toUpperCase() ||
                      "C"}
                  </div>

                  <div>
                    <strong>
                      {`${cadeteSeleccionado?.cadeteApellido || ""} ${cadeteSeleccionado?.cadeteNombre || ""}`.trim()}
                    </strong>

                    <span>
                      DNI{" "}
                      {cadeteSeleccionado
                        ?.cadeteDni || "-"}
                    </span>
                  </div>

                </div>

              </div>

              <div className="cad-v2-modal-body">

                <CadeteFormEdit
                  cadete={
                    cadeteSeleccionado
                  }
                  onClose={(data) =>
                    actualizaCadete(data)
                  }
                  onClick={
                    cerrarModalCadete
                  }
                />

              </div>

            </div>
          </Modal>
        )}
    </div>
  );
};

export default Cadetes;